import { useSubmitPayment } from './useSubmitPayment';

export const useBuyTop = ({ item, table, id }) => {
    const submit = useSubmitPayment();
    const buy = (plan) => () => submit({ plan, table, id, item });

    return {
        buyTopPremium: buy('premium'),
        buyTopOne: buy('top1'),
        buyTopTwo: buy('top2'),
        buyTopThree: buy('top3'),
    };
};
